import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialTransferService = {
    options: async () => axios.get(`${API_URL}/material-transfers/options/all`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    list: async () => axios.post(`${API_URL}/material-transfers/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-transfers/${id}`).then(({data}) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_URL}/material-transfers/${id}`).then(({data}) => data).catch((err) => {throw err}),
    saveBefore: async (formData) => axios.post(`${API_URL}/material-transfers/before-store`, formData).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData) => axios.post(`${API_URL}/material-transfers`, formData).then(({data}) => data).catch((err) => { throw err }),
}

export default MaterialTransferService;